const mEditionProductCard = {
  mEditionProductCard: {
    alerts: {
      updateProducto: {
        error: 'Un error ha ocurrido. Verifica los datos ingresados y vuelve a intentarlo.',
        success: 'Los datos del producto fueron editados exitosamente.'
      }
    },

    buttonPrimary: 'GUARDAR',

    inputs: {
      activo: {
        label: 'Estado de Venta',
        message: '* Para activar la venta del producto este debe tener al menos una formación incluida y un precio configurado.',
        textFalse: 'Desactivo',
        textTrue: 'Activo'
      },

      categoria: {
        label: 'Categoría del Producto'
      },

      descripcion: {
        label: 'Descripción del Producto',
        message: '* De 10 a 120 caracteres',
        placeholder: 'Escribe aquí una descripción'
      },

      etiquetas: {
        label: 'Etiquetas del Producto',
        placeholder: 'Escribe aquí una etiqueta y presiona enter'
      },

      video: {
        label: 'Url de Video',
        message: '* Coloca aquí la url de vimeo o youtube'
      },

      visible: {
        label: 'Estado en Tienda',
        textFalse: 'Oculto',
        textTrue: 'Visible'
      },

      vidroop: {
        alumnos: 'Máximo alumnos',
        proyectos: 'Máximo cursos',
        emails: 'Máximo emails',
        message: '* Solo números'
      }
    },

    selectCardTypes: 'Seleccionar otro tipo de tarjeta',

    validation: {
      descripcion: {
        maxLength: 'La longitud permitida es de 10 a 120 caracteres.',
        minLength: 'La longitud permitida es de 10 a 120 caracteres.',
        required: 'Descripción es requerida.'
      },

      alumnos: {
        required: 'Alumnos es requerido.'
      },

      categoria: {
        required: 'Categoria es requerido.'
      },

      proyectos: {
        required: 'Curso es requerido.'
      },

      emails: {
        required: 'Emails es requerido.'
      },

      video: {
        required: 'Url de video es requerida.',
        validUrl: 'La url ingresada es incorrecta.'
      }
    }
  }
}

export default mEditionProductCard
